
export default {
  path: 'dashboard',
  childRoutes: [
  ],
};
